// @flow
import Enum from '../../types/Enum';

export class ALIGNMENT extends Enum<string> {
  static BASELINE = new ALIGNMENT('baseline');
  static START = new ALIGNMENT('flex-start');
  static CENTER = new ALIGNMENT('center');
  static END = new ALIGNMENT('flex-end');
  static STRETCH = new ALIGNMENT('stretch');
  static SPACE_BETWEEN = new ALIGNMENT('space-between');
  static SPACE_AROUND = new ALIGNMENT('space-around');
  static isLocked = true;
}

export default {
  ALIGNMENT,
};



// WEBPACK FOOTER //
// ../react-lib/src/components/layouts/layout.constants.js